export default {
  data() {
    return {
      // eslint-disable-next-line
      engineeringDisciplineOptions: [
        "Aerospace",
        "Aviation",
        "Biomedical",
        "Chemical",
        "Civil",
        "Comms",
        "Control",
        "Electrical",
        "Electronics",
        "Environmental",
        "Fire",
        "Instrumentation",
        "IT",
        "Marine",
        "Mechanical",
        "Mining",
        "Mutli",
        "Nuclear",
        "Other",
        "Process",
        "Risk",
        "Robotics",
        "Rotating Equipment",
        "Software",
        "Structural",
        "System",
        "Telecommunications",
        "Undefined"
      ]
    };
  }
};
